import styled, { css } from 'styled-components';
import { TABLET_BREAK, MEDIA_BORDER_RADIUS } from '../../themes';
const rootSize = (props) => css `
  height: ${props.$height}px;
`;
const unsupportedVideo = css `
  background-image: url('https://assets.community.com/preview-unavailable.png');
  background-size: contain;
  background-repeat: no-repeat;
  height: 224px;
  video {
    width: 300px;
  }
`;
export const Root = styled.div `
  position: relative;
  border-radius: ${MEDIA_BORDER_RADIUS};
  overflow: hidden;
  width: 100%;
  max-width: 404px;
  max-height: 720px;
  ${(props) => props.$height && rootSize(props)}
  outline: none;
  @media (min-width: ${TABLET_BREAK}) {
    max-width: 100%;
  }
  .Video-overlay {
    display: none;
  }
  &.overlay {
    .Video-overlay {
      display: flex;
    }
  }
  video {
    border-radius: ${MEDIA_BORDER_RADIUS};
    outline: none;
    height: inherit;
    max-height: 250px;
    width: 100%;
    object-fit: cover;
    display: block;
    &.overlay {
      transform: scale(1.2);
    }
  }
`;
export const VideoWrapper = styled.div `
  transition: background-color 1s;
  background-color: ${(props) => (props.$loaded ? 'transparent' : '#E0E0E0')};
  position: relative;
  overflow: hidden;
  outline: none;
  border-radius: 16px;
  ${(props) => props.$unsupported && unsupportedVideo}
`;
export const Overlay = styled.div `
  height: 60px;
  width: 60px;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  position: absolute;
  top: calc(50% - 30px);
  left: calc(50% - 30px);
  svg {
    color: white;
    font-size: 22px;
    position: relative;
    left: 3px;
  }
`;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiU3R5bGVkVmlkZW8uanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi9zcmMvanMvY29tcG9uZW50cy9NZWRpYS9TdHlsZWRWaWRlby5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxPQUFPLE1BQU0sRUFBRSxFQUFFLEdBQUcsRUFBRSxNQUFNLG1CQUFtQixDQUFBO0FBRS9DLE9BQU8sRUFBRSxZQUFZLEVBQUUsbUJBQW1CLEVBQUUsTUFBTSxjQUFjLENBQUE7QUFFaEUsTUFBTSxRQUFRLEdBQUcsQ0FBQyxLQUFLLEVBQUUsRUFBRSxDQUFDLEdBQUcsQ0FBQTtZQUNuQixLQUFLLENBQUMsT0FBTztDQUN4QixDQUFBO0FBRUQsTUFBTSxnQkFBZ0IsR0FBRyxHQUFHLENBQUE7Ozs7Ozs7O0NBUTNCLENBQUE7QUFFRCxNQUFNLENBQUMsTUFBTSxJQUFJLEdBQUcsTUFBTSxDQUFDLEdBQUcsQ0FBQTs7bUJBRVgsbUJBQW1COzs7OztJQUtsQyxDQUFDLEtBQUssRUFBRSxFQUFFLENBQUMsS0FBSyxDQUFDLE9BQU8sSUFBSSxRQUFRLENBQUMsS0FBSyxDQUFDOzt1QkFFeEIsWUFBWTs7Ozs7Ozs7Ozs7O3FCQVlkLG1CQUFtQjs7Ozs7Ozs7Ozs7Q0FXdkMsQ0FBQTtBQUVELE1BQU0sQ0FBQyxNQUFNLFlBQVksR0FBRyxNQUFNLENBQUMsR0FBRyxDQUFBOztzQkFFaEIsQ0FBQyxLQUFLLEVBQUUsRUFBRSxDQUFDLENBQUMsS0FBSyxDQUFDLE9BQU8sQ0FBQyxDQUFDLENBQUMsYUFBYSxDQUFDLENBQUMsQ0FBQyxTQUFTLENBQUM7Ozs7O0lBS3hFLENBQUMsS0FBSyxFQUFFLEVBQUUsQ0FBQyxLQUFLLENBQUMsWUFBWSxJQUFJLGdCQUFnQjtDQUNwRCxDQUFBO0FBRUQsTUFBTSxDQUFDLE1BQU0sT0FBTyxHQUFHLE1BQU0sQ0FBQyxHQUFHLENBQUE7Ozs7Ozs7Ozs7Ozs7Ozs7O0NBaUJoQyxDQUFBIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHN0eWxlZCwgeyBjc3MgfSBmcm9tICdzdHlsZWQtY29tcG9uZW50cydcblxuaW1wb3J0IHsgVEFCTEVUX0JSRUFLLCBNRURJQV9CT1JERVJfUkFESVVTIH0gZnJvbSAnLi4vLi4vdGhlbWVzJ1xuXG5jb25zdCByb290U2l6ZSA9IChwcm9wcykgPT4gY3NzYFxuICBoZWlnaHQ6ICR7cHJvcHMuJGhlaWdodH1weDtcbmBcblxuY29uc3QgdW5zdXBwb3J0ZWRWaWRlbyA9IGNzc2BcbiAgYmFja2dyb3VuZC1pbWFnZTogdXJsKCdodHRwczovL2Fzc2V0cy5jb21tdW5pdHkuY29tL3ByZXZpZXctdW5hdmFpbGFibGUucG5nJyk7XG4gIGJhY2tncm91bmQtc2l6ZTogY29udGFpbjtcbiAgYmFja2dyb3VuZC1yZXBlYXQ6IG5vLXJlcGVhdDtcbiAgaGVpZ2h0OiAyMjRweDtcbiAgdmlkZW8ge1xuICAgIHdpZHRoOiAzMDBweDtcbiAgfVxuYFxuXG5leHBvcnQgY29uc3QgUm9vdCA9IHN0eWxlZC5kaXZgXG4gIHBvc2l0aW9uOiByZWxhdGl2ZTtcbiAgYm9yZGVyLXJhZGl1czogJHtNRURJQV9CT1JERVJfUkFESVVTfTtcbiAgb3ZlcmZsb3c6IGhpZGRlbjtcbiAgd2lkdGg6IDEwMCU7XG4gIG1heC13aWR0aDogNDA0cHg7XG4gIG1heC1oZWlnaHQ6IDcyMHB4O1xuICAkeyhwcm9wcykgPT4gcHJvcHMuJGhlaWdodCAmJiByb290U2l6ZShwcm9wcyl9XG4gIG91dGxpbmU6IG5vbmU7XG4gIEBtZWRpYSAobWluLXdpZHRoOiAke1RBQkxFVF9CUkVBS30pIHtcbiAgICBtYXgtd2lkdGg6IDEwMCU7XG4gIH1cbiAgLlZpZGVvLW92ZXJsYXkge1xuICAgIGRpc3BsYXk6IG5vbmU7XG4gIH1cbiAgJi5vdmVybGF5IHtcbiAgICAuVmlkZW8tb3ZlcmxheSB7XG4gICAgICBkaXNwbGF5OiBmbGV4O1xuICAgIH1cbiAgfVxuICB2aWRlbyB7XG4gICAgYm9yZGVyLXJhZGl1czogJHtNRURJQV9CT1JERVJfUkFESVVTfTtcbiAgICBvdXRsaW5lOiBub25lO1xuICAgIGhlaWdodDogaW5oZXJpdDtcbiAgICBtYXgtaGVpZ2h0OiAyNTBweDtcbiAgICB3aWR0aDogMTAwJTtcbiAgICBvYmplY3QtZml0OiBjb3ZlcjtcbiAgICBkaXNwbGF5OiBibG9jaztcbiAgICAmLm92ZXJsYXkge1xuICAgICAgdHJhbnNmb3JtOiBzY2FsZSgxLjIpO1xuICAgIH1cbiAgfVxuYFxuXG5leHBvcnQgY29uc3QgVmlkZW9XcmFwcGVyID0gc3R5bGVkLmRpdmBcbiAgdHJhbnNpdGlvbjogYmFja2dyb3VuZC1jb2xvciAxcztcbiAgYmFja2dyb3VuZC1jb2xvcjogJHsocHJvcHMpID0+IChwcm9wcy4kbG9hZGVkID8gJ3RyYW5zcGFyZW50JyA6ICcjRTBFMEUwJyl9O1xuICBwb3NpdGlvbjogcmVsYXRpdmU7XG4gIG92ZXJmbG93OiBoaWRkZW47XG4gIG91dGxpbmU6IG5vbmU7XG4gIGJvcmRlci1yYWRpdXM6IDE2cHg7XG4gICR7KHByb3BzKSA9PiBwcm9wcy4kdW5zdXBwb3J0ZWQgJiYgdW5zdXBwb3J0ZWRWaWRlb31cbmBcblxuZXhwb3J0IGNvbnN0IE92ZXJsYXkgPSBzdHlsZWQuZGl2YFxuICBoZWlnaHQ6IDYwcHg7XG4gIHdpZHRoOiA2MHB4O1xuICBiYWNrZ3JvdW5kLWNvbG9yOiByZ2JhKDAsIDAsIDAsIDAuNyk7XG4gIGRpc3BsYXk6IGZsZXg7XG4gIGFsaWduLWl0ZW1zOiBjZW50ZXI7XG4gIGp1c3RpZnktY29udGVudDogY2VudGVyO1xuICBib3JkZXItcmFkaXVzOiA1MCU7XG4gIHBvc2l0aW9uOiBhYnNvbHV0ZTtcbiAgdG9wOiBjYWxjKDUwJSAtIDMwcHgpO1xuICBsZWZ0OiBjYWxjKDUwJSAtIDMwcHgpO1xuICBzdmcge1xuICAgIGNvbG9yOiB3aGl0ZTtcbiAgICBmb250LXNpemU6IDIycHg7XG4gICAgcG9zaXRpb246IHJlbGF0aXZlO1xuICAgIGxlZnQ6IDNweDtcbiAgfVxuYFxuIl19